import moment from "moment";
import { monthOptions } from "../../../helper/constant";

export const GET_1980_YEAR = new Date(1980, 2).getFullYear();

/**
 * monthsDropdown() return months menu for dropdown
 * input selectYear, if current years match select year return active months
 */
export function monthsDropdown(selectedYear) {
  const allMenu = { label: "All", value: "All" };
  const isCurrentYear = selectedYear === new Date().getFullYear();

  if (!isCurrentYear) {
    return [allMenu, ...monthOptions];
  }

  const currentMonth = new Date().getMonth() + 1;
  const activeMonths = monthOptions.slice(0, currentMonth);

  return [allMenu, ...activeMonths];
}

/**
 * getYearsDropdown() return array object menu -> years currentYear till last 1980's . year
 * or pass input of year
 */
export function getYearsDropdown(
  fromDate = GET_1980_YEAR,
  currentYear = new Date().getFullYear()
) {
  const years = [{ label: "All", value: "All" }];

  for (let year = currentYear; year >= fromDate; year--) {
    years.push({ label: year.toString(), value: year });
  }

  return years;
}

/**
 * searchFilter() return filterList by searchItem
 */
export function searchFilter(list, searchItem) {
  let filterValue = [];

  for (let i = 0; i < searchItem.length; i++) {
    const element = searchItem[i];
    // search by string
    if (!element?.type) {
      filterValue = list.filter((currentItem) => {
        const value = currentItem[element.key];
        return value.toLowerCase().includes(element?.search?.toLowerCase());
      });
    }

    if (element?.type === "date") {
      const { month, year } = element.search;
      filterValue = filterValue.filter((currentItem) => {
        let monthStart = month === "" ? 0 : month;
        let monthEnd = month === "" ? 12 : month + 1;
        const yearStart = year === "" ? GET_1980_YEAR : year;
        const yearEnd = year === "" ? new Date().getFullYear() : year;
        const value = currentItem[element.key];

        const [valueDay, valueMonth, valueYear] = value.split("-");
        const itemDate = moment(
          new Date(valueYear, valueMonth - 1, valueDay)
        ).format("YYYY-MM-DD");

        if (month === "" && !year) {
          return true;
        }

        // selected by month
        if (month !== "" && !year) {
          return Number(valueMonth) - 1 === month;
        }

        // search in range
        return moment(itemDate).isBetween(
          moment(new Date(yearStart, monthStart, 1)).format("YYYY-MM-DD"),
          moment(new Date(yearEnd, monthEnd, 0)).format("YYYY-MM-DD")
        );
      });
    }
  }

  return filterValue;
}
